export default __webpack_public_path__ + "static/media/illustration-box-desktop.ec1ba14b.svg";